import styled from 'styled-components'

export const StyledArtistDetails = styled.div`
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: rgba(0, 0, 0, 0.09) 0px 2px 1px, rgba(0, 0, 0, 0.09) 0px 4px 2px,
    rgba(0, 0, 0, 0.09) 0px 8px 4px, rgba(0, 0, 0, 0.09) 0px 16px 8px,
    rgba(0, 0, 0, 0.09) 0px 32px 16px;

  .card {
    color: black;
    background-color: #fff;
    border: 1px solid #ccc;
    position: relative;
    height: 90%;
    width: 60%;
    padding: 20px;
    border-radius: 5px;
  }

  @media (max-width: 1280px) {
    .card {
      width: 80%;
      height: 90%;
    }
  }

  @media (max-width: 1023px) {
    .card {
      width: 94%;
      height: 94%;
    }
  }

  .card__content {
    height: 100%;
    overflow: auto;
  }

  .card__button {
    font-size: 0;
    position: absolute;
    top: -25px;
    right: -25px;
    background-color: #fff;
    color: white;
    border: none;
    padding: 0;
    border-radius: 50%;
    cursor: pointer;
  }

  @media (max-width: 768px) {
    .card__button {
      top: 5px;
      right: 5px;
    }
  }

  .card__button svg {
    fill: #222;
    height: 3rem;
    width: 3rem;
    transition: all 0.3s ease-in-out;
  }

  .card__button svg:hover {
    fill: #393939;
  }
`
